import script from "./LoadingIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingIndicator.vue?vue&type=style&index=0&id=08a03302&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a03302"]])

export default __exports__